import React, {useEffect, useMemo, useRef, useState} from "react";
import {DollarSign, List, MapPin, Plus, User} from "react-feather";
import {FaPlus} from "react-icons/fa";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import {currencyContains} from "../../../api/currencyApi";
import {
    getChargePatterns,
    getCharges,
    getRate,
    saveRate,
    updateRate,
} from "../../../api/finance/rateManagerApi";
import {
    getBulkDropdownData,
    getDropdownData,
    getOtherRefDetails,
    getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import Grid from "../../Grid";
import LoadingSpinner from "../../LoadingSpinner";
import Modal from "../../Modal";
import Button from "../../input/Button";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import SearchDropdown from "../../input/SearchDropdown";
import MapComponent from "../../maps/MapComponent";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import {rateValidation} from "../../validations/RateManager";
import {AUTH_TYPES, FORMS, MAP_TYPES, MODULES} from "../../../const";
import {getRandomIntInclusive} from "../../../helper";
import useUserCompany from "../../../hooks/useUserCompany";
import {Icon, Label} from "semantic-ui-react";
import {ImMinus, ImPlus} from "react-icons/im";
import {FaChevronDown, FaChevronUp} from "react-icons/fa6";
import BulkRate from "./BulkRate";
import CustomAlert from "../../input/CustomAlert";
import InfoList from "../../InfoList";
import {formatFromJsonDate} from "../../../dateConfig";

const mode = {
    CREATE: 1,
    EDIT: 2,
};

const FORM = FORMS.RATE_MANAGER.HEADER.form;

const gridHeaderConst = {
    VEH_CON: "VEH_CON_HEADER",
};

const AddRates = ({editMode, rahId, handleDrawerClose, setUpdateNeeded}) => {
    const user = useSelector((state) => state.user);
    const userCompany = useUserCompany();
    const userCurrency = userCompany ? userCompany.comCurrency : null;
    const userCurrencyName = userCompany ? userCompany.comCurrencyName : null;
    useSelector((state) => state.user.permissions[MODULES.Finance]);

    const gridRef = useRef();
    const [locationDeleteList, setLocationDeleteList] = useState([]);
    const viaLocationSearchRef = useRef();
    const [currentViaLocations, setCurrentViaLocations] = useState([]);
    const [currentViaLocation, setCurrentViaLocation] = useState({});
    const [viaMapLocations, setViaMapLocations] = useState([]);
    const [currentKey, setCurrentKey] = useState(null);
    const [locationClicked, setLocationClicked] = useState(false);
    const [currentLocation, setCurrentLocation] = useState({});
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isPatternLoading, setIsPatternLoading] = useState(false);
    const [uomLoading, setUomLoading] = useState(false);

    const [rateTypeOpt, setRateTypeOpt] = useState("");
    const [statusOpt, setStatusOpt] = useState("");
    const [activeOpt, setActiveOpt] = useState("");
    const [uomOpt, setUomOpt] = useState("");
    const [calcTypeOpt, setCalcTypeOpt] = useState("");
    const [addDeductOpt, setAddDeductOpt] = useState("");
    const [revCostOpt, setRevCostOpt] = useState("");
    const [vehicleTypeOpt, setVehicleTypeOpt] = useState("");
    const [ceilingOpt, setCeilingOpt] = useState("");
    const [chargeOpt, setChargeOpt] = useState("");
    const [patternsOpt, setPatternsOpt] = useState([]);
    const [searchFieldReset, setSearchFieldReset] = useState(false);

    const [customerId, setCustomerId] = useState("");
    const [revCost, setRevCost] = useState("");
    const [shipper, setShipper] = useState(null);
    const [customerSupplier, setCustomerSupplier] = useState("");
    const [rateType, setRateType] = useState("");
    const [vehicleContainer, setVehicleContainer] = useState("");
    const [vehicleContainerType, setVehicleContainerType] = useState(-1);
    const [currency, setCurrency] = useState(userCurrency);
    const [charge, setCharge] = useState("");
    const [pattern, setPattern] = useState("");
    const [patternText, setPatternText] = useState("");
    const [rateName, setRateName] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [formula, setFormula] = useState("");
    const [addDeduct, setAddDeduct] = useState("");
    const [calcType, setCalcType] = useState("");
    const [uom, setUom] = useState("");
    const [status, setStatus] = useState(2);
    const [active, setActive] = useState(1);
    const [company, setCompany] = useState(
        userCompany ? userCompany.comId : null,
    );

    const [clickedButton, setClickedButton] = useState("");
    const [mapLocations, setMapLocations] = useState({});

    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [ratesLoading, setRatesLoading] = useState(false);
    const [currentErrors, setCurrentErrors] = useState({});
    const [deletedList, setDeletedList] = useState([]);

    const [pickup, setPickup] = useState(null);
    const [pickupLocation, setPickupLocation] = useState({});
    const [delivery, setDelivery] = useState(null);
    const [deliverLocation, setDeliverLocation] = useState({});
    const [ceiling, setCeiling] = useState("");
    const [viaCount, setViaCount] = useState(0);
    const [uomGroup, setUomGroup] = useState("");

    const [isBlurred, setIsBlurred] = useState(false);

    // Accordion state
    const [stakeholderAcActive, setStakeholderAcActive] = useState(true);
    const [chargeAcActive, setChargeAcActive] = useState(true);
    const [rateAcActive, setRateAcActive] = useState(true);
    const [locAcActive, setLocAcActive] = useState(true);

    const [vehConTypeWiseState, setVehConTypeWiseState] = useState({});

    const [vehicleContainerObj, setVehicleContainerObj] = useState({});
    const [vehicleContainerList, setVehicleContainerList] = useState([]);
    const [groupedGridData, setGroupedGridData] = useState([]);
    const [modalKey, setModalKey] = useState(1);
    const [changeToFlat, setChangeToFlat] = useState(true);
    const vehConToDeleteRef = useRef(-1);
    const prevVehConType = useRef(-1);

    /*
    Dynamically change the mandatory status and availability of location fields based on charge pattern
    change the chp_rate_loc_status

      1 - ALL (Non-Mandatory)
      2 - Single (Non-Mandatory)
      3 - Start - End (Non-Mandatory)
      4 - None
      5 - ALL (Mandatory)
      6 - Single (Mandatory)
      7 - Start - End (Mandatory)
      8 - ALL (Start End Mandatory)
    */

    const [rateLocStatus, setRateLocStatus] = useState(1);

    const bulkAddModal = useRef(null);

    const isVehConRow = (params) => {
        return params.data.section === gridHeaderConst.VEH_CON;
    };

    let vehConCellClassRules = useMemo(
        () => ({
            "header-cell": 'data.section === "VEH_CON_HEADER"',
        }),
        [],
    );

    const memoizedGroupedGridData = useMemo(
        () => groupedGridData.filter((data) => !data.hide),
        [groupedGridData],
    );

    const memoizedFilteredGridData = useMemo(
        () =>
            groupedGridData.filter(
                (data) => data.section !== gridHeaderConst.VEH_CON,
            ),
        [groupedGridData],
    );

    useEffect(() => {
        let vehConObj = {};
        const vehConList = [];
        const rateListWithHeaders = [];
        let canChangeToFlat = true;
        for (const [key, value] of Object.entries(vehConTypeWiseState)) {
            const currentKey = parseFloat(key);
            vehConObj = {...vehConObj, [currentKey]: value.label};
            vehConList.push(currentKey);
            rateListWithHeaders.push({
                section: gridHeaderConst.VEH_CON,
                start: value.label,
                vehConId: currentKey,
                showRates: value.showRates,
                count: value.count,
            });
            if (canChangeToFlat) {
                canChangeToFlat = value.count <= 1;
            }
            rateListWithHeaders.push(...value.rates);
        }
        setChangeToFlat(canChangeToFlat);
        setGroupedGridData(rateListWithHeaders);
        setVehicleContainerObj(vehConObj);
        setVehicleContainerList(vehConList);
    }, [vehConTypeWiseState]);

    useEffect(() => {
        setCurrency(userCurrency);
    }, [userCurrency]);

    const [auditInfo, setAuditInfo] = useState({});

    useEffect(() => {
        setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);

    useEffect(() => {
        (async () => {
            if (editMode && rahId) {
                setRatesLoading(true);
                const rate = await getRate(rahId);

                setRateType(rate.rahRateTypeFor);
                setRevCost(rate.rahRevcost);
                setCharge(rate.rahCharge);
                setPattern(rate.rehPattern);
                setUomGroup(rate.rahUomGroup);
                setRateLocStatus(rate.rahRateLocStatus);

                setPatternText(
                    JSON.stringify({
                        chpId: rate.rehPattern,
                        chpUomGroup: rate.rahUomGroup,
                        chpRateLocStatus: rate.rahRateLocStatus,
                    }),
                );

                setRateName(rate.rahName);
                setVehicleContainerType(rate.rahVehcon);
                setVehicleContainer(rate.rahVehicleType);
                setFromDate(rate.rahFromDate?.split("T")[0]);
                setToDate(rate.rahToDate?.split("T")[0]);
                setCustomerId(rate.rahCustomer);
                setCustomerSupplier(rate.rahReference);
                setShipper(rate.rahShipper);
                setCalcType(rate.rahCalcType);
                setUom(rate.rahUom);
                setFormula(rate.rahFormular);
                setAddDeduct(rate.rahAddDeduct);
                setCurrency(rate.rahCurrency);
                setStatus(rate.rahStatus);
                setActive(rate.rahActive);
                setCompany(rate.rahCompany);

                setCeiling(rate.rahCelling);
                setAuditInfo({
                    createdDate: rate.createdDate,
                    createdBy: rate.createdBy,
                    lastModifiedBy: rate.lastModifiedBy,
                    lastModifiedDate: rate.lastModifiedDate,
                });

                for (let rateLocation of rate?.rateLocationsResponseList) {
                    if (rateLocation.ralLocationType === 1) {
                        setPickupLocation({
                            ralId: rateLocation.ralId,
                            pick: rateLocation.ralLocation,
                            pickLocation: rateLocation.ralLocationName,
                            locName: rateLocation.ralLocationName,
                            locId: rateLocation.ralLocation,
                            locAddress: rateLocation.ralLocationName,
                            locLat: rateLocation.ralLocationLat
                                ? parseFloat(rateLocation.ralLocationLat)
                                : null,
                            locLong: rateLocation.ralLocationLon
                                ? parseFloat(rateLocation.ralLocationLon)
                                : null,
                        });
                    }

                    if (rateLocation.ralLocationType === 2) {
                        setDeliverLocation({
                            ralId: rateLocation.ralId,
                            deliver: rateLocation.ralLocation,
                            deliveryLocation: rateLocation.ralLocationName,
                            locName: rateLocation.ralLocationName,
                            locId: rateLocation.ralLocation,
                            locAddress: rateLocation.ralLocationName,
                            locLat: rateLocation.ralLocationLat
                                ? parseFloat(rateLocation.ralLocationLat)
                                : null,
                            locLong: rateLocation.ralLocationLon
                                ? parseFloat(rateLocation.ralLocationLon)
                                : null,
                        });
                    }

                    if (rateLocation.ralLocationType === 3) {
                        setCurrentViaLocations((prev) => [
                            ...prev,
                            {
                                ralId: rateLocation.ralId,
                                locName: rateLocation.ralLocationName,
                                locId: rateLocation.ralLocation,
                                locAddress: rateLocation.ralLocationName,
                                locLat: rateLocation.ralLocationLat
                                    ? parseFloat(rateLocation.ralLocationLat)
                                    : null,
                                locLong: rateLocation.ralLocationLon
                                    ? parseFloat(rateLocation.ralLocationLon)
                                    : null,
                            },
                        ]);
                    }
                }

                let currentDetailObj = {};
                for (let rateDetail of rate?.rateDetailsResponseList) {
                    const rateObj = {
                        radId: rateDetail.radId,
                        start: rateDetail.radStart,
                        end: rateDetail.radEnd,
                        min: rateDetail.radMin,
                        rate: rateDetail.radRate,
                        vehConId: rateDetail.radVehConType,
                        hide: false,
                        persisted: true,
                    };
                    currentDetailObj = {
                        ...currentDetailObj,
                        [rateDetail.radVehConType]: currentDetailObj[
                            rateDetail.radVehConType
                            ]
                            ? {
                                ...currentDetailObj[rateDetail.radVehConType],
                                rates: [
                                    ...currentDetailObj[rateDetail.radVehConType].rates,
                                    {
                                        ...rateObj,
                                        id: currentDetailObj[rateDetail.radVehConType].count,
                                    },
                                ],
                                count: currentDetailObj[rateDetail.radVehConType].count + 1,
                            }
                            : {
                                label: rateDetail.radVehConTypeValue,
                                rates: [{...rateObj, id: 0}],
                                count: 1,
                                showRates: true,
                            },
                    };
                }

                setVehConTypeWiseState(currentDetailObj);

                setRatesLoading(false);
            }
        })();
    }, [rahId, editMode]);

    useEffect(() => {
        setViaCount(currentViaLocations?.length);
    }, [currentViaLocations.length]);

    const togglePopup = () => {
        setIsOpen(!isOpen);
    };

    const modalRef = useRef();
    const openModal = () => {
        modalRef.current?.showModal();
    };

    const closeModal = () => {
        modalRef.current?.close();
    };

    useEffect(() => {
        (async () => {
            if (charge === null) return;
            if (charge) {
                setIsPatternLoading(true);
                const patterns = await getChargePatterns(charge);
                setPatternsOpt(patterns);
                setIsPatternLoading(false);
            }
        })();
    }, [charge]);

    useEffect(() => {
        (async () => {
            setIsLoading(true);

            const charges = await getCharges();
            setChargeOpt(charges);

            const {
                status = [],
                active = [],
                rate_type_for: rateTypes = [],
                veh_con: vehicleTypes = [],
                revcost: revCost = [],
                add_ded: addDeduct = [],
                calc_type: calcTypes = [],
                ceiling_value: ceiling = [],
            } = await getBulkDropdownData([
                {key: "status"},
                {key: "active"},
                {
                    key: "rate_type_for",
                    authenticated: true,
                    authorities: [
                        "RATE_MANAGER_FORM_ADD_RATE_TRANSPORTER",
                        "RATE_MANAGER_FORM_ADD_RATE_CUSTOMER",
                    ],
                },
                {key: "veh_con"},
                {key: "revcost"},
                {key: "add_ded"},
                {key: "calc_type"},
                {key: "ceiling_value"},
            ]);
            setRateTypeOpt(rateTypes);
            setVehicleTypeOpt(vehicleTypes);
            setRevCostOpt(revCost);
            setAddDeductOpt(addDeduct);
            setCalcTypeOpt(calcTypes);
            setStatusOpt(status);
            setActiveOpt(active);
            setCeilingOpt(ceiling);

            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        if (
            (currentLocation.locLat && currentLocation.locLong) ||
            locationClicked
        ) {
            setMapLocations({
                lat: currentLocation.locLat,
                lng: currentLocation.locLong,
            });
        } else {
            setMapLocations({
                lat: 0,
                lng: 0,
            });
        }

        setLocationClicked(false);
    }, [currentLocation.locLat, currentLocation.locLong, locationClicked]);

    const locationMandatoryCheck = () => {
        let errors = {};

        if (![5, 6, 7, 8].includes(rateLocStatus)) return errors;

        if (
            (rateLocStatus === 5 ||
                rateLocStatus === 6 ||
                rateLocStatus === 7 ||
                rateLocStatus === 8) &&
            !pickupLocation?.locId
        ) {
            errors.rehStartLoc = `${rateLocStatus === 6 ? "Location" : "Start Location"} is mandatory`;
        }

        if (
            (rateLocStatus === 5 || rateLocStatus === 7 || rateLocStatus === 8) &&
            !deliverLocation?.locId
        ) {
            errors.rehEndLoc = "End Location is mandatory";
        }

        if (rateLocStatus === 5 && currentViaLocations.length === 0) {
            errors.rehViaLoc = "Via Locations are mandatory";
        }

        return errors;
    };

    const cellEditorParams = (params) => {
        let value = params.value ? Math.abs(Number(params.value)) : 0;
        let vehConType = params.data.vehConId;
        switch (params.colDef.field) {
            case "start":
                setVehConTypeWiseState((prevState) => ({
                    ...prevState,
                    [vehConType]: {
                        ...prevState[vehConType],
                        rates: prevState[vehConType].rates.map((row) => {
                            if (row.id === params.data.id) {
                                if (row.persisted) {
                                    return {
                                        ...row,
                                        start: value,
                                        mode: mode.EDIT,
                                    };
                                } else {
                                    return {
                                        ...row,
                                        start: value,
                                    };
                                }
                            }
                            return row;
                        }),
                    },
                }));
                break;
            case "end":
                setVehConTypeWiseState((prevState) => ({
                    ...prevState,
                    [vehConType]: {
                        ...prevState[vehConType],
                        rates: prevState[vehConType].rates.map((row) => {
                            if (row.id === params.data.id) {
                                if (row.persisted) {
                                    return {
                                        ...row,
                                        end: value,
                                        mode: mode.EDIT,
                                    };
                                } else {
                                    return {
                                        ...row,
                                        end: value,
                                    };
                                }
                            }
                            return row;
                        }),
                    },
                }));
                break;
            case "min":
                setVehConTypeWiseState((prevState) => ({
                    ...prevState,
                    [vehConType]: {
                        ...prevState[vehConType],
                        rates: prevState[vehConType].rates.map((row) => {
                            if (row.id === params.data.id) {
                                if (row.persisted) {
                                    return {
                                        ...row,
                                        min: value,
                                        mode: mode.EDIT,
                                    };
                                } else {
                                    return {
                                        ...row,
                                        min: value,
                                    };
                                }
                            }
                            return row;
                        }),
                    },
                }));
                break;
            case "rate":
                setVehConTypeWiseState((prevState) => ({
                    ...prevState,
                    [vehConType]: {
                        ...prevState[vehConType],
                        rates: prevState[vehConType].rates.map((row) => {
                            if (row.id === params.data.id) {
                                if (row.persisted) {
                                    return {
                                        ...row,
                                        rate: value,
                                        mode: mode.EDIT,
                                    };
                                } else {
                                    return {
                                        ...row,
                                        rate: value,
                                    };
                                }
                            }
                            return row;
                        }),
                    },
                }));
                break;
            default:
                break;
        }
    };

    // Add rates to vehicle/container type
    const handleAddRow = (vehConId, showRates) => {
        if (!calcType) {
            toast.warn("Please select a calc type before adding rates.", {
                autoClose: 5000,
                containerId: "Main",
            });
            return;
        }

        const rates = vehConTypeWiseState[vehConId]?.rates || [];
        let newStart = 0;

        if (rates.length > 0) {
            const lastRate = rates[rates.length - 1];
            newStart = lastRate.end + 1;
        }

        const newRow = {
            start: newStart,
            end: newStart + 1,
            min: 0,
            rate: 0,
            mode: mode.CREATE,
            vehConId,
            hide: false,
            persisted: false,
        };

        setVehConTypeWiseState((prevState) => ({
            ...prevState,
            [vehConId]: {
                ...prevState[vehConId],
                rates: showRates
                    ? [
                        ...prevState[vehConId].rates,
                        {...newRow, id: prevState[vehConId].count},
                    ]
                    : [
                        ...prevState[vehConId].rates.map((ra) => ({
                            ...ra,
                            hide: false,
                        })),
                        {...newRow, id: prevState[vehConId].count},
                    ],
                count: prevState[vehConId].count + 1,
                showRates: true,
            },
        }));
    };

    // Delete rate from vehicle/container type
    const handleRemoveRow = (vehConId, rateId) => {
        const vcId = parseInt(vehConId);
        const raId = parseInt(rateId);

        setVehConTypeWiseState((prevState) => {
            const currentVehCon = prevState[vcId];
            if (!currentVehCon) {
                return prevState;
            }
            // Remove and reorder rate list
            const mappedFilteredRates = currentVehCon.rates.reduce((acc, ra) => {
                if (ra.id === raId) {
                    return acc;
                }
                acc.push({...ra, id: ra.id > raId ? ra.id - 1 : ra.id});
                return acc;
            }, []);
            return {
                ...prevState,
                [vcId]: {
                    ...currentVehCon,
                    rates: mappedFilteredRates,
                    count: currentVehCon.count - 1,
                },
            };
        });
    };

    const locationTypes = {
        PICK: "Pick",
        DELIVER: "Deliver",
        VIA: "Via",
    };

    const locationClickHandler = (type) => {
        const randomNumber = getRandomIntInclusive(1, 100000);
        setLocationClicked(true);
        switch (type) {
            case locationTypes.PICK:
                setCurrentLocation(pickupLocation);
                setClickedButton(locationTypes.PICK);
                setCurrentKey(`${type}_${randomNumber}`);
                break;
            case locationTypes.DELIVER:
                setCurrentLocation(deliverLocation);
                setClickedButton(locationTypes.DELIVER);
                setCurrentKey(`${type}_${randomNumber}`);
                break;
            case locationTypes.VIA:
                setClickedButton(locationTypes.VIA);
                setCurrentKey(`${type}_${randomNumber}`);
                break;
            default:
        }
    };

    const handleLocationChange = (data, type, all = false) => {
        if (!all) {
            setMapLocations({
                lat: data.retField10,
                lng: data.retField9,
            });
        }

        switch (type) {
            case locationTypes.PICK: {
                if (!all) {
                    setPickupLocation((prev) => ({
                        ...prev,
                        pick: data.retId,
                        pickLocation: data.retField1,
                        locName: data.retField1,
                        locId: data.retId,
                        locAddress: data.retField2,
                        locLat: data.retField10,
                        locLong: data.retField9,
                        mode: prev.ralId ? mode.EDIT : mode.CREATE,
                    }));
                } else {
                    setPickupLocation((prev) => ({
                        ...prev,
                        pick: data,
                        pickLocation: "All Locations",
                        locName: "All Locations",
                        locId: data,
                        locAddress: "All Locations",
                        locLat: null,
                        locLong: null,
                        mode: prev.ralId ? mode.EDIT : mode.CREATE,
                    }));
                }
                break;
            }
            case locationTypes.DELIVER: {
                if (!all) {
                    setDeliverLocation((prev) => ({
                        ...prev,
                        deliver: data.retId,
                        deliveryLocation: data.retField1,
                        locName: data.retField1,
                        locId: data.retId,
                        locAddress: data.retField2,
                        locLat: data.retField10,
                        locLong: data.retField9,
                        mode: prev.ralId ? mode.EDIT : mode.CREATE,
                    }));
                } else {
                    setDeliverLocation((prev) => ({
                        ...prev,
                        deliver: data,
                        deliveryLocation: "All Locations",
                        locName: "All Locations",
                        locId: data,
                        locAddress: "All Locations",
                        locLat: null,
                        locLong: null,
                        mode: prev.ralId ? mode.EDIT : mode.CREATE,
                    }));
                }
                break;
            }
            case locationTypes.VIA: {
                setCurrentViaLocations([
                    ...currentViaLocations,
                    {
                        ...data,
                        mode: mode.CREATE,
                    },
                ]);
                break;
            }
            default:
        }

        if (type === locationTypes.VIA) {
            setViaMapLocations((prev) => [
                ...prev,
                {lat: data.locLat, lng: data.locLong},
            ]);
            setCurrentViaLocation({});
            viaLocationSearchRef.current.reset();
        }

        if (all) {
            closeModal();
        }
    };

    const handleAddRowToVia = () => {
        if (!currentViaLocation.locId) {
            toast.error("Please select a location", {
                autoClose: 5000,
                containerId: "Modal",
            });
            return;
        }
        handleLocationChange(currentViaLocation, locationTypes.VIA);
    };

    const addPickupLocation = (all = false) => {
        if (!all && !pickup) {
            toast.error("Please select a location", {
                autoClose: 5000,
                containerId: "Modal",
            });
            return;
        }

        handleLocationChange(all ? -1 : pickup, locationTypes.PICK, all);
        setPickup(null);
    };

    const addDeliverLocation = (all = false) => {
        if (!all && !delivery) {
            toast.error("Please select a location", {
                autoClose: 5000,
                containerId: "Modal",
            });
            return;
        }
        handleLocationChange(all ? -1 : delivery, locationTypes.DELIVER, all);
        setDelivery(null);
    };

    let modelContent = <></>;

    switch (clickedButton) {
        case locationTypes.PICK: {
            modelContent = (
                <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                    <div style={{display: "flex", gap: "10px"}}>
                        <div>
                            <label>Select Pickup location</label>
                            <SearchDropdown
                                clearable={true}
                                authenticated={true}
                                field={"pickupLocation"}
                                module={MODULES.Finance}
                                form={FORMS.RATE_MANAGER.LOCATIONS.form}
                                style={{minWidth: "500px", maxWidth: "500px"}}
                                key={currentKey}
                                multiGrid={true}
                                multiGridCurrentValue={
                                    currentLocation ? currentLocation.locName : ""
                                }
                                reset={searchFieldReset}
                                setReset={setSearchFieldReset}
                                api={getOtherRefDetails}
                                threshold={3}
                                apiDependency={{
                                    type: "location",
                                    value: "",
                                }}
                                returnFullObject={true}
                                onResultSelect={(data) => setPickup(data)}
                                fieldInfo={{
                                    tableName: "masterdata.tms_m_locations",
                                    primaryKey: "loc_id",
                                    fieldName: "loc_name",
                                    id: currentLocation?.locId,
                                }}
                            />
                        </div>
                        <Button
                            authenticated={true}
                            editMode={editMode}
                            module={MODULES.Finance}
                            form={FORMS.RATE_MANAGER.LOCATIONS.form}
                            onClick={() => addPickupLocation(false)}
                            Icon={FaPlus}
                            style={{height: "40px", marginTop: "20px"}}
                            label={"Add Location"}
                        />
                        <Button
                            onClick={() => {
                                addPickupLocation(true);
                            }}
                            // Icon={Plus}
                            style={{height: "40px", marginTop: "20px"}}
                            label="All Locations"
                            className="ui secondary button"
                        />
                    </div>
                    <MapComponent
                        initialLocations={[mapLocations]}
                        type={MAP_TYPES.STATIC}
                        activeTab="rate-master"
                    />
                </div>
            );
            break;
        }
        case locationTypes.DELIVER: {
            modelContent = (
                <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                    <div style={{display: "flex", gap: "10px"}}>
                        <div>
                            <label>Select Deliver location</label>
                            <SearchDropdown
                                authenticated={true}
                                clearable={true}
                                field={"deliverLocation"}
                                module={MODULES.Finance}
                                form={FORMS.RATE_MANAGER.LOCATIONS.form}
                                key={currentKey}
                                multiGrid={true}
                                multiGridCurrentValue={
                                    currentLocation ? currentLocation.locName : ""
                                }
                                reset={searchFieldReset}
                                setReset={setSearchFieldReset}
                                api={getOtherRefDetails}
                                threshold={3}
                                apiDependency={{
                                    type: "location",
                                    value: "",
                                }}
                                returnFullObject={true}
                                onResultSelect={(data) => setDelivery(data)}
                                fieldInfo={{
                                    tableName: "masterdata.tms_m_locations",
                                    primaryKey: "loc_id",
                                    fieldName: "loc_name",
                                    id: currentLocation?.locId,
                                }}
                            />
                        </div>
                        <Button
                            authenticated={true}
                            editMode={editMode}
                            module={MODULES.Finance}
                            form={FORMS.RATE_MANAGER.LOCATIONS.form}
                            onClick={() => addDeliverLocation(false)}
                            Icon={FaPlus}
                            label={"Add Location"}
                            style={{height: "40px", marginTop: "20px"}}
                        />
                        <Button
                            onClick={() => {
                                addDeliverLocation(true);
                            }}
                            style={{height: "40px", marginTop: "20px"}}
                            label="All Locations"
                            className="ui secondary button"
                        />
                    </div>
                    <MapComponent
                        initialLocations={[mapLocations]}
                        type={MAP_TYPES.STATIC}
                        activeTab="rate-master"
                    />
                </div>
            );
            break;
        }
        case locationTypes.VIA: {
            modelContent = (
                <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                    <label>Select Via locations</label>
                    <div
                        style={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                        }}
                    >
                        <div className="field">
                            <SearchDropdown
                                authenticated={true}
                                field={"viaLocation"}
                                module={MODULES.Finance}
                                form={FORMS.RATE_MANAGER.LOCATIONS.form}
                                key={currentKey}
                                ref={viaLocationSearchRef}
                                // readOnly={viewOnlyMode}
                                // editMode={editMode}
                                multiGrid={true}
                                multiGridCurrentValue={
                                    currentViaLocation ? currentViaLocation.locName : ""
                                }
                                returnFullObject={true}
                                reset={searchFieldReset}
                                setReset={setSearchFieldReset}
                                api={getOtherRefDetails}
                                threshold={3}
                                apiDependency={{
                                    type: "location",
                                    value: "",
                                }}
                                onResultSelect={(data) => {
                                    setCurrentViaLocation({
                                        locName: data.retField1,
                                        locId: data.retId,
                                        locAddress: data.retField2,
                                        locLat: data.retField10,
                                        locLong: data.retField9,
                                    });
                                }}
                                fieldInfo={{
                                    tableName: "masterdata.tms_m_locations",
                                    primaryKey: "loc_id",
                                    fieldName: "loc_name",
                                    id: currentViaLocation?.locId,
                                }}
                            />
                        </div>
                        <Button
                            authenticated={true}
                            editMode={editMode}
                            module={MODULES.Finance}
                            form={FORMS.RATE_MANAGER.LOCATIONS.form}
                            onClick={handleAddRowToVia}
                            Icon={FaPlus}
                            label={"Add"}
                        />
                    </div>
                    <MapComponent
                        initialLocations={
                            viaMapLocations.length === 0
                                ? [{lat: 0, lng: 0}]
                                : viaMapLocations
                        }
                        type={MAP_TYPES.STATIC}
                        activeTab="rate-master"
                        showDirections={true}
                    />

                    <Grid
                        searchable={false}
                        config={[
                            {
                                headerName: "Via Locations",
                                field: "locName",
                            },
                            {
                                field: "Delete",
                                cellRenderer: ButtonRenderer,
                                cellRendererParams: (params) => ({
                                    consider: AUTH_TYPES.CREATE,
                                    clickHandler: () => {
                                        setLocationDeleteList((prev) => [
                                            ...prev,
                                            params.data.ralId,
                                        ]);

                                        const updatedViaLocations = currentViaLocations?.filter(
                                            (loc) => loc.locId !== params.data.locId,
                                        );

                                        setViaMapLocations((prev) =>
                                            prev.filter(
                                                (loc) =>
                                                    loc.lat !== params.data.locLat &&
                                                    loc.lng !== params.data.locLong,
                                            ),
                                        );
                                        // setViaCount(viaCount - 1);
                                        setCurrentViaLocations(updatedViaLocations);
                                    },
                                    label: "Delete",
                                    className: "ui red button",
                                    authenticated: true,
                                    form: FORMS.RATE_MANAGER.LOCATIONS.form,
                                    module: MODULES.Finance,
                                    editMode: editMode,
                                }),
                            },
                        ]}
                        content={currentViaLocations}
                        ref={gridRef}
                    />
                </div>
            );

            break;
        }
        default:
    }

    const resetForm = () => {
        setCompany("");
        setRateType("");
        setRevCost("");
        setCharge("");
        setPattern("");
        setRateName("");
        setVehicleContainerType(-1);
        setVehicleContainer("");
        setFromDate("");
        setToDate("");
        setCustomerId("");
        setShipper(null);
        setCalcType("");
        setUom("");
        setFormula("");
        setAddDeduct("");
        setCurrency(143);
        setStatus(2);
        setActive(1);
        setCeiling("");
        setDeliverLocation({});
        setPickupLocation({});
        setViaCount(0);
        setCurrentViaLocations([]);
        setVehConTypeWiseState({});
    };

    const startEndRateMinValidation = () => {
        let isValid = true;
        for (let row of memoizedFilteredGridData) {
            if (row.start < 0 || row.end < 0 || row.rate < 0 || row.min < 0) {
                isValid = false;
                break;
            }
        }
        return isValid;
    };

    const submitRate = async () => {
        setIsSubmitLoading(true);
        setIsBlurred(true);

        const rateErrors = rateValidation({
            rahRateTypeFor: rateType,
            rahReference: customerSupplier,
            rahRevcost: revCost,
            rahCharge: charge,
            rehPattern: pattern,
            rahName: rateName,
            rahVehcon: vehicleContainerType,
            rahVehicleType: vehicleContainer,
            rahCalcType: calcType,
            rahCurrency: currency,
            rahUom: uom,
            rahFromDate: fromDate,
            rahToDate: toDate,
            rahStatus: status,
            rahActive: active,
            rahCelling: ceiling,
        });

        const rateLocationErrors = locationMandatoryCheck();

        let fullErrors = {...rateErrors, ...rateLocationErrors};

        for (let [vehConId, vehConObj] of Object.entries(vehConTypeWiseState)) {
            const zeroStartRows = vehConObj.rates.filter((rate) => rate.start === 0);
            if (zeroStartRows.length > 1) {
                toast.error(
                    `More than one rate in "${vehConObj.label}" has 'Start' = 0. Please fix this before submitting.`,
                    {
                        autoClose: 5000,
                        containerId: "Main",
                    },
                );
                setIsBlurred(false);
                setIsSubmitLoading(false);
                return;
            }
        }

        if (Object.keys(fullErrors).length > 0) {
            setCurrentErrors(fullErrors);
            document.querySelector(".ui.form").classList.add("error");
            toast.error("please Fill the required fields", {
                autoClose: 5000,
                containerId: "Main",
            });
            setIsBlurred(false);
            setIsSubmitLoading(false);
            return;
        } else {
            document.querySelector(".ui.form").classList.remove("error");
            setCurrentErrors({});

            if (new Date(fromDate) > new Date(toDate)) {
                toast.error("From Date should be earlier than or equal to To Date.", {
                    autoClose: 5000,
                    containerId: "Main",
                });
                setIsSubmitLoading(false);
                setIsBlurred(false);
                return;
            }

            if (!startEndRateMinValidation()) {
                toast.error("Please fill all start end min rate fields correctly..", {
                    autoClose: 5000,
                    containerId: "Main",
                });
                setIsBlurred(false);
                setIsSubmitLoading(false);
                return;
            }

            for (let vehConObj of Object.values(vehConTypeWiseState)) {
                if (vehConObj.rates.length === 0) {
                    toast.error(
                        `The ${vehicleContainerType === 1 ? "Vehicle" : "Container"} type ${vehConObj.label} does not have any rates`,
                        {
                            autoClose: 5000,
                            containerId: "Main",
                        },
                    );
                    setIsBlurred(false);
                    setIsSubmitLoading(false);
                    return;
                }
            }

            try {
                if (editMode) {
                    const response = await updateRate({
                        rahId: rahId,
                        rahCompany: company,
                        rahRateTypeFor: rateType,
                        rahReference: customerSupplier,
                        rahRevcost: revCost,
                        rahCharge: charge,
                        rehPattern: pattern,
                        rahName: rateName,
                        rahVehcon: vehicleContainerType,
                        rahVehicleType: vehicleContainer,
                        rahAddDeduct: addDeduct,
                        rahCustomer: customerId,
                        rahShipper: shipper,
                        rahCalcType: calcType,
                        rahCurrency: currency,
                        rahUom: uom,
                        rahDescription: "",
                        rahFormular: formula,
                        rahFromDate: fromDate,
                        rahToDate: toDate,
                        rahGroup: 1,
                        rahStatus: status,
                        rahActive: active,
                        rahPickup: pickupLocation.locId,
                        rahDelivery: deliverLocation.locId,
                        rahCelling: ceiling,
                        ...getUpdateState(),
                        author: user.username,
                    });

                    if (response.status === 200) {
                        toast.success(response.data + " !", {
                            autoClose: 5000,
                            containerId: "Main",
                        });
                        resetForm();
                        handleDrawerClose();
                        setUpdateNeeded(true);
                        setIsBlurred(false);
                    } else {
                        toast.error(response.data, {
                            autoClose: 5000,
                            containerId: "Main",
                        });
                        setIsBlurred(false);
                    }
                } else {
                    if (memoizedFilteredGridData.length === 0) {
                        toast.error("Please add at least one row", {
                            autoClose: 5000,
                            containerId: "Main",
                        });
                        setIsBlurred(false);
                        setIsSubmitLoading(false);
                        return;
                    }
                    const response = await saveRate({
                        rahCompany: company,
                        rahRateTypeFor: rateType,
                        rahReference: customerSupplier,
                        rahRevcost: revCost,
                        rahCharge: charge,
                        rehPattern: pattern,
                        rahName: rateName,
                        rahVehcon: vehicleContainerType,
                        rahVehicleType: vehicleContainer,
                        rahAddDeduct: addDeduct,
                        rahCustomer: customerId,
                        rahShipper: shipper,
                        rahCalcType: calcType,
                        rahCurrency: currency,
                        rahUom: uom,
                        rahDescription: "",
                        rahFormular: formula,
                        rahFromDate: fromDate,
                        rahToDate: toDate,
                        rahGroup: 1,
                        rahStatus: status,
                        rahActive: active,
                        rahPickup: pickupLocation.locId,
                        rahDelivery: deliverLocation.locId,
                        rahCelling: ceiling,
                        rateDetailsRequest: memoizedFilteredGridData?.map((row) => ({
                            radStart: row.start,
                            radEnd: row.end,
                            radMin: row.min,
                            radRate: row.rate,
                            radVehConType: row.vehConId,
                            radVcType: vehicleContainerType,
                            radStatus: 2,
                            radActive: 1,
                        })),
                        rateLocationRequest: [
                            {
                                ralLocation: pickupLocation.locId,
                                ralLocationType: 1,
                                ralDescription: "Start Location",
                                ralStatus: 2,
                                ralActive: 1,
                            },
                            {
                                ralLocation: deliverLocation.locId,
                                ralLocationType: 2,
                                ralDescription: "End Location",
                                ralStatus: 2,
                                ralActive: 1,
                            },
                            ...currentViaLocations.map((loc) => ({
                                ralLocation: loc.locId,
                                ralLocationType: 3,
                                ralDescription: "Via Location",
                                ralStatus: 2,
                                ralActive: 1,
                            })),
                        ],
                        author: user.username,
                    });
                    if (response.status === 200) {
                        toast.success(response.data + " !", {
                            autoClose: 5000,
                            containerId: "Main",
                        });
                        resetForm();
                        handleDrawerClose();
                        setUpdateNeeded(true);
                        setIsBlurred(false);
                    } else {
                        toast.error(response.data, {
                            autoClose: 5000,
                            containerId: "Main",
                        });
                        setIsBlurred(false);
                    }
                }
            } catch (e) {
                if (e?.response?.data) {
                    toast.error(e?.response?.data, {
                        autoClose: 5000,
                        containerId: "Main",
                    });
                } else {
                    toast.error("Error occured", {
                        autoClose: 5000,
                        containerId: "Main",
                    });
                }
            }
        }
        setIsBlurred(false);
        setIsSubmitLoading(false);
    };

    const getUpdateState = () => {
        const locationUpdateState = {
            created: [],
            modified: [],
            deleted: locationDeleteList,
        };

        const updateState = {
            createdRateDetailsRequest: [],
            modifiedRateDetailsRequest: [],
            deletedRateDetailsRequest: deletedList,
            rateLocationRequest: locationUpdateState,
        };

        for (let row of memoizedFilteredGridData) {
            if (row.mode === mode.CREATE) {
                updateState.createdRateDetailsRequest.push({
                    radStart: row.start,
                    radEnd: row.end,
                    radMin: row.min,
                    radRate: row.rate,
                    radVehConType: row.vehConId,
                    radVcType: vehicleContainerType,
                    radStatus: 2,
                    radActive: 1,
                });
            }

            if (row.mode === mode.EDIT) {
                updateState.modifiedRateDetailsRequest.push({
                    radId: row.radId,
                    radStart: row.start,
                    radEnd: row.end,
                    radMin: row.min,
                    radRate: row.rate,
                    radVehConType: row.vehConId,
                    radVcType: vehicleContainerType,
                    radStatus: 2,
                    radActive: 1,
                });
            }
        }

        currentViaLocations?.forEach((location) => {
            if (location.mode === mode.CREATE) {
                locationUpdateState.created.push({
                    ralLocation: location.locId,
                    ralLocationType: 3,
                    ralDescription: "Via Location",
                    ralStatus: 2,
                    ralActive: 1,
                });
            }
        });

        if (pickupLocation.mode) {
            if (pickupLocation.mode === mode.EDIT) {
                locationUpdateState.modified.push({
                    ralId: pickupLocation.ralId,
                    ralLocation: pickupLocation.locId,
                    ralLocationType: 1,
                    ralDescription: "Start Location",
                    ralStatus: 2,
                    ralActive: 1,
                });
            }

            if (pickupLocation.mode === mode.CREATE) {
                locationUpdateState.created.push({
                    ralLocation: pickupLocation.locId,
                    ralLocationType: 1,
                    ralDescription: "Start Location",
                    ralStatus: 2,
                    ralActive: 1,
                });
            }
        }

        if (deliverLocation.mode) {
            if (deliverLocation.mode === mode.EDIT) {
                locationUpdateState.modified.push({
                    ralId: deliverLocation.ralId,
                    ralLocation: deliverLocation.locId,
                    ralLocationType: 2,
                    ralDescription: "End Location",
                    ralStatus: 2,
                    ralActive: 1,
                });
            }

            if (deliverLocation.mode === mode.CREATE) {
                locationUpdateState.created.push({
                    ralLocation: deliverLocation.locId,
                    ralLocationType: 2,
                    ralDescription: "End Location",
                    ralStatus: 2,
                    ralActive: 1,
                });
            }
        }

        return updateState;
    };

    const customerTransporterRef = useRef();
    const shipperRef = useRef();
    const patternRef = useRef();
    const vehicleContainerRef = useRef();

    useEffect(() => {
        if (!charge || !pattern) {
            setUom("");
        }
    }, [charge, pattern]);

    useEffect(() => {
        (async () => {
            setUomLoading(true);
            if (uomGroup) {
                const uom = await getDropdownData("uom", uomGroup);
                setUomOpt(uom);
            } else {
                const uom = await getDropdownData("uom");
                setUomOpt(uom);
            }
            setUomLoading(false);
        })();
    }, [pattern, uomGroup, editMode]);

    const vehicleDeleteRef = useRef();
    const vehConTypeChangeRef = useRef();

    const deleteVehConType = (id) => {
        setVehConTypeWiseState((prevState) => {
            prevState[id].rates.forEach((rate) => {
                if (rate.persisted) {
                    setDeletedList((prevState) => [...prevState, rate.radId]);
                }
            });
            const {[id]: _, ...rest} = prevState;
            return rest;
        });
    };

    const changeVehConType = () => {
        setVehConTypeWiseState({});
        vehicleContainerRef.current.reset();
    };

    return (
        <>
            <CustomAlert
                ref={vehConTypeChangeRef}
                message={`Changing this will reset all vehicle/container types and their rates as well.`}
                onAccept={() => {
                    changeVehConType();
                }}
                onClose={() => {
                    setVehicleContainerType(prevVehConType.current);
                }}
            />
            <CustomAlert
                ref={vehicleDeleteRef}
                message={`Deleting this ${vehicleContainerType === 1 ? "Vehicle" : "Container"} Type will delete its rates as well.`}
                onAccept={() => {
                    deleteVehConType(vehConToDeleteRef.current);
                }}
            />
            <Modal ref={bulkAddModal}>
                <BulkRate
                    key={modalKey}
                    vehConList={vehicleContainerObj}
                    vehicleContainerType={vehicleContainerType}
                    calcType={calcType}
                    saveRates={(vehConTypeList, rates) => {
                        setVehConTypeWiseState((prevState) => {
                            const mappedObject = {...prevState};
                            vehConTypeList.forEach((vehConType) => {
                                const currentCoVeType = mappedObject[vehConType];
                                let currentCount = currentCoVeType.count;
                                const mappedRates = [];

                                /*
                                  Add any persisted rates ids to delete list when clac type is flat
                                  (Since this will be replaced by new rates).
                                */

                                if (calcType === 1) {
                                    currentCoVeType.rates.forEach((rate) => {
                                        if (rate.persisted) {
                                            setDeletedList((prevState) => [...prevState, rate.radId]);
                                        }
                                    });
                                }

                                for (const rate of rates) {
                                    mappedRates.push({
                                        ...rate,
                                        id: calcType === 1 ? 0 : currentCount,
                                        mode: mode.CREATE,
                                        vehConId: vehConType,
                                        hide: false,
                                        persisted: false,
                                    });
                                    currentCount += 1;
                                }
                                mappedObject[vehConType] = {
                                    ...currentCoVeType,
                                    rates:
                                        calcType === 1
                                            ? mappedRates
                                            : [...currentCoVeType.rates, ...mappedRates],
                                    count: calcType === 1 ? 1 : currentCount,
                                    showRates: true,
                                };
                            });
                            return mappedObject;
                        });
                        bulkAddModal.current?.close();
                    }}
                />
            </Modal>
            {isBlurred && (
                <div className="blur-overlay">
                    <LoadingSpinner message={editMode ? "Updating..." : "Saving..."}/>
                </div>
            )}
            {isLoading || ratesLoading ? (
                <LoadingSpinner/>
            ) : (
                <div className="ui form" style={{zoom: 0.75}}>
                    <div className="ui segment">
                        <div className="ui dividing header">Rate header</div>
                        {/*Stakeholder Info*/}
                        <div className="ui styled accordion" style={{width: "100%"}}>
                            <div
                                className={`title ${stakeholderAcActive ? "active" : ""}`}
                                onClick={() =>
                                    setStakeholderAcActive((prevState) => !prevState)
                                }
                            >
                                <div>
                                    Stakeholder Info
                                    <User size={14} style={{marginLeft: "10px"}}/>
                                    <i className="dropdown icon"></i>
                                </div>
                            </div>
                            <div className={`content ${stakeholderAcActive ? "active" : ""}`}>
                                <div className="three fields">
                                    <Dropdown
                                        module={MODULES.Finance}
                                        form={FORM}
                                        editMode={editMode}
                                        field="rah_rate_type"
                                        label="Rate Type"
                                        required={true}
                                        clearable={false}
                                        placeholder="Select Rate Type"
                                        options={rateTypeOpt}
                                        value={rateType}
                                        onChange={(e, data) => {
                                            setRateType(data.value);
                                            setCustomerSupplier("");
                                            setShipper(null);
                                            customerTransporterRef.current.reset();
                                            shipperRef.current.reset();
                                            if (data.value === 2) {
                                                setRevCost(2);
                                            } else if (data.value === 1) {
                                                setRevCost(1);
                                            } else {
                                                setRevCost("");
                                            }
                                        }}
                                        error={currentErrors.rahRateTypeFor}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahRateTypeFor: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                    />

                                    <SearchDropdown
                                        ref={customerTransporterRef}
                                        module={MODULES.Finance}
                                        form={FORM}
                                        field="rah_customer_transpoter"
                                        label={rateType === 2 ? "Transporter" : "Customer"}
                                        required={true}
                                        clearable={true}
                                        onClear={() => {
                                            setCustomerSupplier("");
                                            setShipper(null);
                                        }}
                                        editMode={editMode}
                                        reset={searchFieldReset}
                                        setReset={setSearchFieldReset}
                                        onResultSelect={(data) => setCustomerSupplier(data)}
                                        api={getOtherRefSearchDropdown}
                                        apiDependency={{
                                            type: "stakeholder_type",
                                            value:
                                                rateType === 2 ? "Transporter" : "Billing Customer",
                                        }}
                                        fieldInfo={{
                                            tableName: "masterdata.tms_m_stakeholder",
                                            primaryKey: "stk_id",
                                            fieldName: "stk_name",
                                            id: customerSupplier,
                                        }}
                                        error={currentErrors.rahReference}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahReference: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                        disabled={!rateType}
                                    />
                                    <SearchDropdown
                                        ref={shipperRef}
                                        module={MODULES.Finance}
                                        form={FORM}
                                        field="rah_shipper"
                                        label={rateType === 2 ? "Requesting Customer" : "Shipper"}
                                        clearable={true}
                                        onClear={() => setShipper(null)}
                                        editMode={editMode}
                                        reset={searchFieldReset}
                                        setReset={setSearchFieldReset}
                                        onResultSelect={(data) => setShipper(data)}
                                        api={getOtherRefSearchDropdown}
                                        apiDependency={
                                            rateType === 2
                                                ? {
                                                    type: "user_stakeholder",
                                                    value: "Requesting Customer",
                                                    param2: user.username,
                                                }
                                                : {
                                                    type: "stakeholder_type",
                                                    value: "shipper_by_billing_customer",
                                                    param2: customerSupplier ? customerSupplier.toString() : "",
                                                }
                                        }
                                        fieldInfo={{
                                            tableName: "masterdata.tms_m_stakeholder",
                                            primaryKey: "stk_id",
                                            fieldName: "stk_name",
                                            id: shipper,
                                        }}
                                        disabled={!rateType}
                                    />
                                </div>
                            </div>
                        </div>

                        {/*Charge Info*/}
                        <div
                            className="ui styled accordion"
                            style={{width: "100%", marginTop: "15px"}}
                        >
                            <div
                                className={`title ${chargeAcActive ? "active" : ""}`}
                                onClick={() => setChargeAcActive((prevState) => !prevState)}
                            >
                                <div>
                                    Charge Info
                                    <DollarSign size={14} style={{marginLeft: "10px"}}/>
                                    <i className="dropdown icon"></i>
                                </div>
                            </div>
                            <div className={`content ${chargeAcActive ? "active" : ""}`}>
                                <div className="three fields">
                                    <Dropdown
                                        module={MODULES.Finance}
                                        form={FORM}
                                        editMode={editMode}
                                        field="rah_revcost"
                                        label="Revenue/Cost"
                                        clearable={false}
                                        required={true}
                                        placeholder="Select Revenue/Cost"
                                        options={revCostOpt}
                                        value={revCost}
                                        onChange={(e, data) => setRevCost(data.value)}
                                        error={currentErrors.rahRevcost}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahRevcost: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                        disabled={true}
                                    />
                                    <Dropdown
                                        module={MODULES.Finance}
                                        form={FORM}
                                        search={true}
                                        editMode={editMode}
                                        field="rah_charge"
                                        label="Charge"
                                        clearable={false}
                                        required={true}
                                        placeholder="Select Charge"
                                        options={chargeOpt}
                                        value={charge}
                                        onChange={(e, data) => {
                                            setCharge(data.value);
                                            setPattern("");
                                            setRateLocStatus(1);
                                            patternRef.current.reset();
                                        }}
                                        error={currentErrors.rahCharge}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahCharge: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                    />
                                    <Dropdown
                                        ref={patternRef}
                                        module={MODULES.Finance}
                                        form={FORM}
                                        editMode={editMode}
                                        field="rah_pattern"
                                        label="Patterns"
                                        clearable={false}
                                        required={true}
                                        placeholder={
                                            isPatternLoading ? "Loading" : "Select pattern"
                                        }
                                        options={patternsOpt}
                                        disabled={
                                            !charge || isPatternLoading || patternsOpt.length === 0
                                        }
                                        value={patternText}
                                        onChange={(e, data) => {
                                            setPatternText(data.value);
                                            const val = data.value ? JSON.parse(data.value) : {};
                                            setPattern(parseInt(val?.chpId));
                                            setUomGroup(val?.chpUomGroup);
                                            setRateLocStatus(parseInt(val?.chpRateLocStatus));
                                        }}
                                        error={currentErrors.rehPattern}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rehPattern: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                    />
                                    <Input
                                        module={MODULES.Finance}
                                        form={FORM}
                                        editMode={editMode}
                                        field="rah_formula"
                                        label="Formula"
                                        placeholder="Formula"
                                        value={formula}
                                        onChange={(e) => setFormula(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {/*Rate Info*/}
                        <div
                            className="ui styled accordion"
                            style={{width: "100%", marginTop: "15px"}}
                        >
                            <div
                                className={`title ${rateAcActive ? "active" : ""}`}
                                onClick={() => setRateAcActive((prevState) => !prevState)}
                            >
                                <div>
                                    Rate Info
                                    <List size={14} style={{marginLeft: "10px"}}/>
                                    <i className="dropdown icon"></i>
                                </div>
                            </div>
                            <div className={`content ${rateAcActive ? "active" : ""}`}>
                                <div className="three fields">
                                    <Input
                                        module={MODULES.Finance}
                                        form={FORM}
                                        editMode={editMode}
                                        type="text"
                                        field="rah_name"
                                        label="Name for the rate"
                                        placeholder="Name for the rate"
                                        value={rateName}
                                        required={true}
                                        onChange={(e) => setRateName(e.target.value)}
                                        error={currentErrors.rahName}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahName: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                    />
                                    <Input
                                        type="date"
                                        module={MODULES.Finance}
                                        form={FORM}
                                        editMode={editMode}
                                        field="rah_from_date"
                                        label="From Date"
                                        required={true}
                                        placeholder="From Date"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                        error={currentErrors.rahFromDate}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahFromDate: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                    />
                                    <Input
                                        type="date"
                                        module={MODULES.Finance}
                                        form={FORM}
                                        editMode={editMode}
                                        field="rah_to_date"
                                        label="To Date"
                                        placeholder="To Date"
                                        min={!editMode ? fromDate ?? null : fromDate}
                                        value={toDate}
                                        onChange={(e) => {
                                            if (e.target.value >= fromDate) setToDate(e.target.value);
                                            else {
                                                setToDate(fromDate);
                                                toast.error(
                                                    "To date should be greater than from date",
                                                    {
                                                        autoClose: 5000,
                                                        containerId: "Main",
                                                    },
                                                );
                                            }
                                        }}
                                        error={currentErrors.rahToDate}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahToDate: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                        disabled={!fromDate}
                                    />
                                </div>
                                <div className="three fields">
                                    <Dropdown
                                        module={MODULES.Finance}
                                        form={FORM}
                                        editMode={editMode}
                                        field="rah_addd_educt"
                                        label="Add/Deduct"
                                        clearable
                                        placeholder="Select Add/Deduct"
                                        options={addDeductOpt}
                                        value={addDeduct}
                                        onChange={(e, data) => setAddDeduct(data.value)}
                                    />

                                    <SearchDropdown
                                        module={MODULES.Finance}
                                        form={FORM}
                                        field="rah_currency"
                                        label={"Currency"}
                                        required={true}
                                        // clearable={true}
                                        onClear={() => setCurrency(143)}
                                        defaultValue={userCurrencyName}
                                        editMode={editMode}
                                        reset={searchFieldReset}
                                        setReset={setSearchFieldReset}
                                        onResultSelect={(data) => setCurrency(data)}
                                        api={currencyContains}
                                        fieldInfo={{
                                            tableName: "masterdata.tms_vm_reg_currency",
                                            primaryKey: "cur_id",
                                            fieldName: "cur_currency",
                                            id: currency,
                                        }}
                                        error={currentErrors.rahCurrency}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahCurrency: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                        readOnly={true}
                                    />
                                    <Dropdown
                                        module={MODULES.Finance}
                                        form={FORM}
                                        editMode={editMode}
                                        field="rah_uom"
                                        label="UOM"
                                        clearable={false}
                                        required={true}
                                        placeholder={uomLoading ? "Loading..." : "Select UOM"}
                                        options={uomOpt}
                                        value={uom}
                                        onChange={(e, data) => setUom(data.value)}
                                        error={currentErrors.rahUom}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahUom: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                        disabled={uomLoading || uomOpt.length <= 0 || !pattern}
                                    />
                                </div>
                                <div className="three fields">
                                    <Dropdown
                                        module={MODULES.Finance}
                                        form={FORM}
                                        editMode={editMode}
                                        field="rah_calc_type"
                                        label="Calc Types"
                                        clearable={false}
                                        required={true}
                                        placeholder="Select Calc Types"
                                        options={calcTypeOpt}
                                        value={calcType}
                                        disabled={!changeToFlat}
                                        onChange={(e, data) => {
                                            setCalcType(data.value);
                                        }}
                                        error={currentErrors.rahCalcType}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahCalcType: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                    />
                                    <Dropdown
                                        required={true}
                                        label={"Ceiling"}
                                        value={ceiling}
                                        options={ceilingOpt}
                                        placeholder="Ceiling"
                                        clearable={false}
                                        onChange={(e, data) => {
                                            setCeiling(data.value);
                                        }}
                                        error={currentErrors.rahCelling}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahCelling: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                    />

                                    <Dropdown
                                        module={MODULES.Finance}
                                        form={FORM}
                                        editMode={editMode}
                                        field="rah_status"
                                        label="Status"
                                        clearable={false}
                                        required={true}
                                        placeholder="Select Status"
                                        options={statusOpt}
                                        value={status}
                                        onChange={(e, data) => setStatus(data.value)}
                                        error={currentErrors.rahStatus}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahStatus: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                    />
                                    <Dropdown
                                        module={MODULES.Finance}
                                        form={FORM}
                                        editMode={editMode}
                                        field="rah_active"
                                        label="Active"
                                        clearable={false}
                                        required={true}
                                        placeholder="Select Active"
                                        options={activeOpt}
                                        value={active}
                                        onChange={(e, data) => setActive(data.value)}
                                        error={currentErrors.rahActive}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {rahActive: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        {/*Location Info*/}
                        <div
                            className="ui styled accordion"
                            style={{width: "100%", marginTop: "15px"}}
                        >
                            <div
                                className={`title ${locAcActive ? "active" : ""}`}
                                onClick={() => setLocAcActive((prevState) => !prevState)}
                            >
                                <div>
                                    Location Info
                                    <MapPin size={14} style={{marginLeft: "10px"}}/>
                                    <i className="dropdown icon"></i>
                                </div>
                            </div>
                            <div className={`content ${locAcActive ? "active" : ""}`}>
                                <div className="three fields" style={{margin: "5px"}}>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: "30%",
                                            }}
                                        >
                                            <Input
                                                style={{
                                                    width: "90%",
                                                }}
                                                label={
                                                    rateLocStatus === 2 || rateLocStatus === 6
                                                        ? "Location"
                                                        : "Pickup Location"
                                                }
                                                placeholder="No location"
                                                error={currentErrors.rehStartLoc}
                                                resetError={() =>
                                                    setCurrentErrors((prevState) => {
                                                        const {rehStartLoc: _, ...rest} = prevState;
                                                        return rest;
                                                    })
                                                }
                                                required={
                                                    rateLocStatus === 5 ||
                                                    rateLocStatus === 6 ||
                                                    rateLocStatus === 7 ||
                                                    rateLocStatus === 8
                                                }
                                                readOnly={true}
                                                value={
                                                    pickupLocation.locId === -1
                                                        ? "All Locations"
                                                        : pickupLocation.locName
                                                }
                                            />
                                            <Button
                                                style={{marginTop: "22px"}}
                                                Icon={Plus}
                                                disabled={rateLocStatus === 4}
                                                onClick={() => {
                                                    locationClickHandler(locationTypes.PICK);
                                                    openModal();
                                                }}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: "30%",
                                            }}
                                        >
                                            <Input
                                                label="Deliver Location"
                                                placeholder="No location"
                                                style={{width: "90%"}}
                                                required={
                                                    rateLocStatus === 5 ||
                                                    rateLocStatus === 7 ||
                                                    rateLocStatus === 8
                                                }
                                                error={currentErrors.rehEndLoc}
                                                resetError={() =>
                                                    setCurrentErrors((prevState) => {
                                                        const {rehEndLoc: _, ...rest} = prevState;
                                                        return rest;
                                                    })
                                                }
                                                readOnly={true}
                                                value={
                                                    deliverLocation.locId === -1
                                                        ? "All Locations"
                                                        : deliverLocation.locName
                                                }
                                            />
                                            <Button
                                                style={{marginTop: "22px"}}
                                                Icon={Plus}
                                                onClick={() => {
                                                    locationClickHandler(locationTypes.DELIVER);
                                                    openModal();
                                                }}
                                                disabled={
                                                    rateLocStatus === 2 ||
                                                    rateLocStatus === 4 ||
                                                    rateLocStatus === 6
                                                }
                                            />
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: "30%",
                                            }}
                                        >
                                            <Input
                                                style={{width: "90%"}}
                                                required={rateLocStatus === 5}
                                                error={currentErrors.rehViaLoc}
                                                resetError={() =>
                                                    setCurrentErrors((prevState) => {
                                                        const {rehViaLoc: _, ...rest} = prevState;
                                                        return rest;
                                                    })
                                                }
                                                label="Via Locations"
                                                placeholder="0 locations"
                                                readOnly={true}
                                                value={
                                                    viaCount > 0 ? `${viaCount} Locations` : "0 locations"
                                                }
                                            />
                                            <Button
                                                style={{marginTop: "22px"}}
                                                Icon={Plus}
                                                onClick={() => {
                                                    locationClickHandler(locationTypes.VIA);
                                                    openModal();
                                                }}
                                                disabled={
                                                    rateLocStatus !== 1 &&
                                                    rateLocStatus !== 5 &&
                                                    rateLocStatus !== 8
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*Vehicle Info*/}
                        <div className="ui segment">
                            <div className="ui dividing header">Vehicle / Container Info</div>
                            <div
                                style={{
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    gap: "10px",
                                    padding: "5px",
                                }}
                            >
                                <div style={{display: "flex", width: "100%"}}>
                                    <div className="two fields" style={{width: "100%"}}>
                                        <Dropdown
                                            module={MODULES.Finance}
                                            form={FORM}
                                            editMode={editMode}
                                            field="rah_revcost"
                                            label="Vehicle Type Or Container Type"
                                            required={true}
                                            clearable={false}
                                            placeholder="Vehicle/Container Type"
                                            options={vehicleTypeOpt}
                                            value={vehicleContainerType}
                                            disabled={editMode}
                                            onChange={(e, data) => {
                                                prevVehConType.current = vehicleContainerType;
                                                setVehicleContainerType(
                                                    data.value === "" ? -1 : data.value,
                                                );
                                                if (Object.keys(vehConTypeWiseState).length > 0) {
                                                    vehConTypeChangeRef.current?.openAlert();
                                                } else {
                                                    changeVehConType();
                                                }
                                            }}
                                            error={currentErrors.rahVehcon}
                                            resetError={() =>
                                                setCurrentErrors((prevState) => {
                                                    const {rahVehcon: _, ...rest} = prevState;
                                                    return rest;
                                                })
                                            }
                                        />
                                        <SearchDropdown
                                            hideMultiValueList={true}
                                            ref={vehicleContainerRef}
                                            module={MODULES.Finance}
                                            form={FORM}
                                            field="rah_vehicle_type"
                                            label={"Vehicle/Container Type"}
                                            required={true}
                                            returnFullObject={true}
                                            multiValueTwoWayBinding={true}
                                            multiple={true}
                                            multiValues={vehicleContainerObj}
                                            editMode={editMode}
                                            reset={searchFieldReset}
                                            setReset={setSearchFieldReset}
                                            onResultSelect={(data) => {
                                                const key = parseInt(data.key);
                                                if (!vehicleContainerObj[key]) {
                                                    setVehConTypeWiseState((prevState) => ({
                                                        ...prevState,
                                                        [key]: {
                                                            label: data.title,
                                                            rates: [],
                                                            count: 0,
                                                            showRates: true,
                                                        },
                                                    }));
                                                }
                                            }}
                                            api={getOtherRefSearchDropdown}
                                            threshold={1}
                                            occupySpace={false}
                                            apiDependency={
                                                vehicleContainerType === 1
                                                    ? {
                                                        type: "vehicle_type",
                                                        value: "",
                                                    }
                                                    : {
                                                        type: "container_type",
                                                        value: "",
                                                    }
                                            }
                                            error={currentErrors.rahVehicleType}
                                            resetError={() =>
                                                setCurrentErrors((prevState) => {
                                                    const {rahVehicleType: _, ...rest} = prevState;
                                                    return rest;
                                                })
                                            }
                                            disabled={vehicleContainerType === -1}
                                        />
                                    </div>
                                </div>

                                <div
                                    className="ui padded segment"
                                    style={{width: "100%", height: "100px", overflow: "auto"}}
                                >
                                    {vehicleContainerList.length === 0 ? (
                                        <div
                                            className="ui grey header"
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            {vehicleContainerType === -1
                                                ? "No Vehicle/Container Types are listed for this rate master."
                                                : `No ${vehicleContainerType === 1 ? "Vehicle" : "Container"} Types are listed for this rate master.`}
                                        </div>
                                    ) : (
                                        <>
                                            {Object.entries(vehicleContainerObj).map(
                                                ([key, value]) => (
                                                    <Label as="a" style={{marginBottom: "10px"}}>
                                                        {value}
                                                        <Icon
                                                            name="delete"
                                                            onClick={() => {
                                                                const currentKey = parseInt(key);
                                                                if (
                                                                    vehConTypeWiseState[currentKey].rates.length >
                                                                    0
                                                                ) {
                                                                    vehConToDeleteRef.current = currentKey;
                                                                    vehicleDeleteRef.current?.openAlert();
                                                                } else {
                                                                    deleteVehConType(currentKey);
                                                                }
                                                            }}
                                                        />
                                                    </Label>
                                                ),
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ui divider"></div>
                    <div className="ui segment">
                        <Button
                            authenticated={true}
                            editMode={editMode}
                            module={MODULES.Finance}
                            form={FORMS.RATE_MANAGER.DETAILS.form}
                            onClick={() => {
                                setModalKey((prevState) => prevState + 1);
                                bulkAddModal?.current.showModal();
                            }}
                            Icon={FaPlus}
                            label={"Add"}
                            disabled={
                                calcType === null ||
                                calcType === undefined ||
                                calcType === "" ||
                                vehicleContainerList.length === 0
                            }
                        />
                        <Grid
                            multiRowSelection={true}
                            module={MODULES.Finance}
                            searchable={false}
                            stopEditingWhenCellsLoseFocus={true}
                            onCellEditingStopped={cellEditorParams}
                            // onCellDoubleClicked={cellDoubleClickHandler}
                            config={[
                                {
                                    headerName: "Start",
                                    field: "start",
                                    module: MODULES.Finance,
                                    cellClassRules: vehConCellClassRules,
                                    colSpan: (params) => (isVehConRow(params) ? 1 : 1),
                                    primaryForm: FORMS.RATE_MANAGER.DETAILS.form,
                                    authenticated: true,
                                    cellEditorFramework: "agNumberCellEditor",
                                    editable: (params) => !isVehConRow(params),
                                    tooltipValueGetter: (params) => {
                                        return "press Enter to set the value";
                                    },
                                    cellStyle: (params) => {
                                        if (isVehConRow(params)) {
                                            return {};
                                        }
                                        if (params.value < 0) {
                                            return {
                                                background: "red",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            };
                                        } else {
                                            return {
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            };
                                        }
                                    },
                                },
                                {
                                    headerName: "End",
                                    field: "end",
                                    module: MODULES.Finance,
                                    primaryForm: FORMS.RATE_MANAGER.DETAILS.form,
                                    authenticated: true,
                                    cellEditor: "agNumberCellEditor",
                                    cellClassRules: vehConCellClassRules,
                                    colSpan: (params) => (isVehConRow(params) ? 3 : 1),
                                    editable: (params) => !isVehConRow(params),
                                    tooltipValueGetter: (params) => {
                                        return "press Enter to set the value";
                                    },
                                    cellStyle: (params) => {
                                        if (params.value < 0) {
                                            return {
                                                background: "red",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            };
                                        } else {
                                            return {
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            };
                                        }
                                    },
                                },
                                {
                                    headerName: "Min",
                                    field: "min",
                                    module: MODULES.Finance,
                                    primaryForm: FORMS.RATE_MANAGER.DETAILS.form,
                                    authenticated: true,
                                    cellEditor: "agNumberCellEditor",
                                    editable: (params) => !isVehConRow(params),
                                    tooltipValueGetter: (params) => {
                                        return "press Enter to set the value";
                                    },
                                    cellStyle: (params) => {
                                        if (params.value < 0) {
                                            return {
                                                background: "red",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            };
                                        } else {
                                            return {
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            };
                                        }
                                    },
                                    valueFormatter: (params) => {
                                        const value = params.value || 0;
                                        return value.toFixed(2); // Always display with 2 decimal places
                                    },
                                },
                                {
                                    headerName: "Rate",
                                    field: "rate",
                                    module: MODULES.Finance,
                                    primaryForm: FORMS.RATE_MANAGER.DETAILS.form,
                                    authenticated: true,
                                    cellEditor: "agNumberCellEditor",
                                    editable: (params) => !isVehConRow(params),
                                    tooltipValueGetter: (params) => {
                                        return "press Enter to set the value";
                                    },
                                    cellStyle: (params) => {
                                        if (params.value < 0) {
                                            return {
                                                background: "red",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            };
                                        } else {
                                            return {
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            };
                                        }
                                    },
                                    valueFormatter: (params) => {
                                        const value = params.value || 0;
                                        return value.toFixed(2); // Always display with 2 decimal places
                                    },
                                },
                                {
                                    field: "Action",
                                    width: "400px",
                                    cellClassRules: vehConCellClassRules,
                                    cellRendererSelector: (param) => {
                                        if (!isVehConRow(param)) {
                                            return {
                                                component: () => (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            height: "100%",
                                                        }}
                                                    >
                                                        <button
                                                            type="button"
                                                            className="ui red button icon"
                                                            style={{
                                                                padding: "8px 12px",
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                            onClick={() => {
                                                                if (param.data.persisted) {
                                                                    setDeletedList((prev) => [
                                                                        ...prev,
                                                                        param.data.radId,
                                                                    ]);
                                                                }
                                                                handleRemoveRow(param.data.vehConId, param.data.id);
                                                            }}
                                                        >
                                                            <ImMinus style={{ color: "#ffffff", fontSize: "14px" }} />
                                                        </button>
                                                    </div>
                                                ),
                                            };
                                        } else {
                                            return {
                                                component: () => (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: "6px",
                                                            height: "100%",
                                                        }}
                                                    >
                                                        <button
                                                            type="button"
                                                            className="ui primary button icon"
                                                            style={{
                                                                padding: "8px 12px",
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                            disabled={calcType === 1 && param.data.count >= 1}
                                                            onClick={() => handleAddRow(param.data.vehConId, param.data.showRates)}
                                                        >
                                                            <ImPlus style={{ color: "#ffffff", fontSize: "14px" }} />
                                                        </button>

                                                        <button
                                                            type="button"
                                                            className="ui primary button icon"
                                                            style={{
                                                                padding: "8px 12px",
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                            disabled={param.data.count === 0}
                                                            onClick={() => {
                                                                setVehConTypeWiseState((prevState) => {
                                                                    const conVehObj = prevState[param.data.vehConId];
                                                                    return {
                                                                        ...prevState,
                                                                        [param.data.vehConId]: {
                                                                            ...conVehObj,
                                                                            rates: conVehObj.rates.map((ra) => ({
                                                                                ...ra,
                                                                                hide: !ra.hide,
                                                                            })),
                                                                            showRates: !conVehObj.showRates,
                                                                        },
                                                                    };
                                                                });
                                                            }}
                                                        >
                                                            {param.data.showRates ? (
                                                                <FaChevronUp style={{ color: "#ffffff", fontSize: "14px" }} />
                                                            ) : (
                                                                <FaChevronDown style={{ color: "#ffffff", fontSize: "14px" }} />
                                                            )}
                                                        </button>
                                                    </div>
                                                ),
                                            };
                                        }
                                    }
                                },
                            ]}
                            content={memoizedGroupedGridData}
                            ref={gridRef}
                        />
                    </div>
                    <>
                        {editMode && (
                            <InfoList
                                title="User Information"
                                content={[
                                    {
                                        title: "Created By",
                                        value: auditInfo.createdBy ? auditInfo.createdBy : "N/A",
                                    },
                                    {
                                        title: "Created Date",
                                        value: auditInfo.createdDate
                                            ? formatFromJsonDate(auditInfo.createdDate)
                                            : "N/A",
                                    },
                                    {
                                        title: "Last Modified By",
                                        value: auditInfo.lastModifiedBy
                                            ? auditInfo.lastModifiedBy
                                            : "N/A",
                                    },
                                    {
                                        title: "Last Modified Date",
                                        value: auditInfo.lastModifiedDate
                                            ? formatFromJsonDate(auditInfo.lastModifiedDate)
                                            : "N/A",
                                    },
                                ]}
                                Icon={User}
                            />
                        )}
                    </>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Button
                            type="submit"
                            template="create"
                            isLoading={isSubmitLoading}
                            create={!editMode}
                            onClick={submitRate}
                            form={FORMS.RATE_MANAGER.HEADER.form}
                            module={MODULES.Finance}
                            authenticated={true}
                            editMode={editMode}
                        />
                    </div>
                </div>
            )}

            <Modal
                ref={modalRef}
                onClose={togglePopup}
                minHeight="80vh"
                minWidth="80vw"
            >
                {modelContent}
            </Modal>
        </>
    );
};

export default AddRates;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
